import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Drawer, ListItem } from '@material-ui/core';
import Button from '../../components/ButtonCustom';
import { portalCfg } from '../../../portal.router.config';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import { getAppCfg } from '../../utils/common';
import { GooglePayIcon, PKPassIcon, WalletWhiteIcon } from '../../components/icons';
import ModalCustom from '../../components/Modal';
import { Link } from 'react-router-dom';

const styles = theme => ({
    box_wallet: {
        margin: 'auto',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2, 4),
        backgroundColor: theme.palette.background.header,
        //backgroundColor: "#000",
        marginTop: theme.spacing(4),
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    googlePay: {
        borderLeft: '1px solid ' + theme.palette.background.secondary,
    }
});

function MobilePassCardView1(props){
    const { classes, t, getApplePass, getAndroidWalletPass, getGooglePass } = props;
    const app_config = getAppCfg();
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title = {t('mobile_pass_card')}
                children={
                    <Grid item>
                        <Grid xs={12} item container justify='center'>
                            <CustomTypo mg_top_xl variant='body2' color='onPrimary' center>{t('mobile_pass_card_desc')}</CustomTypo>
                        </Grid>
                        <Grid xs={12} item alignItems='center'>
                            <Grid item xs={12} sm={4} container justify='center' className={classes.box_wallet} onClick={() => getApplePass()}>
                                <Grid item xs={2}>
                                    <WalletWhiteIcon />
                                </Grid>
                                <Grid item xs={10}>
                                    <CustomTypo variant='body2' color='onPrimary' center>{t('add_to_apple_wallet')}</CustomTypo>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={4} container justify='center' className={classes.box_wallet} onClick={() => getAndroidWalletPass()}>
                                <Grid item xs={2}>
                                    <WalletWhiteIcon />
                                </Grid>
                                <Grid item xs={10}>
                                    <CustomTypo variant='body2' color='onPrimary' center>{t('add_to_wallet_passes')}</CustomTypo>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} container justify='center' className={classes.box_wallet} onClick={() => getGooglePass()}>
                                <Grid item style={{textAlign: 'right', paddingRight: 8}}>
                                    <WalletWhiteIcon />
                                </Grid>
                                <Grid item className={classes.googlePay}>
                                    <CustomTypo mg_left_sm variant='body2' color='onPrimary'>{t('save_to_phone')}</CustomTypo>
                                </Grid>
                            </Grid>
                        </Grid>
                </Grid>}/>
        </div>
    );
}

function MobilePassCardView(props){
    const { classes, t, urlGooglePay, urlAppleWallet, urlAndroidWallet } = props;
    const app_config = getAppCfg();
    return (
        <div>
            <ModalCustom
                open={props.open}
                onClose={props.onClose}
                title = {t('mobile_pass_card')}
                children={
                    <Grid item style={{paddingBottom: 20}}>
                        <Grid xs={12} item container justify='center'>
                            <CustomTypo mg_top_xl variant='body2' center>{t('mobile_pass_card_desc')}</CustomTypo>
                        </Grid>
                        <Grid xs={12} item alignItems='center'>
                            <a href={urlAppleWallet ? urlAppleWallet : "#"} target="_blank" style={{textDecoration: 'none'}}>
                                <Grid item xs={6} sm={4} container justify='center' className={classes.box_wallet}>
                                    <Grid item xs={2}>
                                        <PKPassIcon/>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <CustomTypo variant='body2' color='onPrimary' center>{t('add_to_apple_wallet')}</CustomTypo>
                                    </Grid>
                                </Grid>
                            </a>
                            <a href={urlAndroidWallet ? urlAndroidWallet : "#"} target="_blank" style={{textDecoration: 'none'}}>
                                <Grid item xs={6} sm={4} container justify='center' className={classes.box_wallet}>
                                    <Grid item xs={2}>
                                        <PKPassIcon height={24} style={{transform: 'rotate(90deg)'}}/>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <CustomTypo variant='body2' color='onPrimary' center>{t('add_to_wallet_passes')}</CustomTypo>
                                    </Grid>
                                </Grid>
                            </a>
                            <a href={urlGooglePay ? urlGooglePay : "#"} target="_blank" style={{textDecoration: 'none'}}>
                                <Grid item xs={10} sm={6} container justify='center' className={classes.box_wallet}>                                
                                    <Grid item style={{textAlign: 'right', paddingRight: 8, display: 'flex', alignItems: 'center'}}>
                                        <GooglePayIcon />
                                        <CustomTypo mg_left_sm variant='body2' color='onPrimary'>
                                            {t('Pay')}
                                        </CustomTypo>
                                    </Grid>
                                    <Grid item className={classes.googlePay}>
                                        <CustomTypo mg_left_sm variant='body2' color='onPrimary'>{t('save_to_phone')}</CustomTypo>
                                    </Grid>
                                </Grid>
                            </a>
                        </Grid>
                </Grid>}/>
        </div>
    );
}
export default withStyles(styles)(withTranslation()(MobilePassCardView));